export default "__VITE_ASSET__d57ad489__"